import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ChakraProvider, Spinner, Center } from '@chakra-ui/react';
import { Provider } from 'react-redux';
import { store } from './store/store';

// Components (always loaded — needed for routing shell)
import Layout from './components/Layout/Layout';
import ProtectedRoute, { AdminRoute } from './components/ProtectedRoute';

// Pages — lazy loaded to reduce initial bundle
const LoginPage = lazy(() => import('./pages/Auth/LoginPage'));
const UsersPage = lazy(() => import('./pages/Users/UsersPage'));
const ClientsPage = lazy(() => import('./pages/Clients/ClientsPage'));
const ClientDetailPage = lazy(() => import('./pages/Clients/ClientDetailPage'));
const CarsPage = lazy(() => import('./pages/CarsPage'));
const InTransitPage = lazy(() => import('./pages/InTransitPage'));
const ArchivePage = lazy(() => import('./pages/Archive/ArchivePage'));
const CarStepperForm = lazy(() => import('./components/Cars/CarStepperForm'));
const CarDetailPage = lazy(() => import('./pages/CarDetailPage'));
const LeadsPage = lazy(() => import('./pages/Calculator/LeadsPage'));
const CalculatorSettingsPage = lazy(() => import('./pages/Calculator/CalculatorSettingsPage'));

const PageSpinner = () => (
  <Center h="100vh">
    <Spinner size="xl" />
  </Center>
);

function App() {
  return (
    <Provider store={store}>
      <ChakraProvider>
        <Router>
          <Suspense fallback={<PageSpinner />}>
          <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/cars" replace />} />

              <Route
                path="users"
                element={
                  <AdminRoute>
                    <UsersPage />
                  </AdminRoute>
                }
              />

              <Route path="clients" element={<ClientsPage />} />
              <Route path="clients/:id" element={<ClientDetailPage />} />

              {/* Cars роути - ОНОВЛЕНО */}
<Route path="cars" element={<CarsPage />} />
<Route path="cars/in-transit" element={<InTransitPage />} />
<Route path="cars/new" element={<CarStepperForm />} />
<Route path="cars/:id" element={<CarDetailPage />} />
{/* <Route path="cars/:id/edit" element={<CarEditPage />} /> */}

              <Route path="leads" element={<LeadsPage />} />
              <Route
                path="calculator-settings"
                element={
                  <AdminRoute>
                    <CalculatorSettingsPage />
                  </AdminRoute>
                }
              />

              <Route path="archive" element={<ArchivePage />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </Suspense>
        </Router>
      </ChakraProvider>
    </Provider>
  );
}

export default App;